import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
    apiKey: "AIzaSyDAH6OLq39pBzLfZWNMRjlv-VTSgLaWPjM",
    authDomain: "personal-efficiency-center.firebaseapp.com",
    projectId: "personal-efficiency-center",
    storageBucket: "personal-efficiency-center.firebasestorage.app",
    messagingSenderId: "959124539549",
    appId: "1:959124539549:web:cc990d9f478be2842bac74"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const db = getFirestore(app);

export { app, auth, db };
